import { toast } from "sonner";
import { Download, Share2 } from "lucide-react";

export const exportPng = async (svg, caption, bg = "#E9F4FA") => {
  const xml = new XMLSerializer().serializeToString(svg);
  const img = new Image();
  img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(xml);
  await img.decode();
  const c = document.createElement("canvas");
  c.width = 1080; c.height = 1200;
  const ctx = c.getContext("2d");
  ctx.fillStyle = bg; ctx.fillRect(0, 0, c.width, c.height);
  const r = Math.min(1000 / img.width, 1000 / img.height);
  const w = img.width * r, h = img.height * r;
  ctx.drawImage(img, 40 + (1000 - w) / 2, 40 + (1000 - h) / 2, w, h);
  ctx.fillStyle = "#132A1D"; ctx.font = "bold 44px Georgia, serif"; ctx.fillText(caption, 40, 1110);
  ctx.fillStyle = "#5C5C5C"; ctx.font = "30px Arial, sans-serif"; ctx.fillText("pame3d.com/juegos · Pame3D · @pame.3d", 40, 1160);
  return new Promise((res) => c.toBlob(res, "image/png"));
};

const downloadBlob = (blob, name) => {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob); a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
};

export const ShareButtons = ({ svgRef, caption, file, url, g, bg }) => {
  const download = async () => {
    try { downloadBlob(await exportPng(svgRef.current, caption, bg), file); toast.success(g.downloaded); }
    catch { toast.error(g.shareError); }
  };
  const share = async () => {
    try {
      const blob = await exportPng(svgRef.current, caption, bg);
      const f = new File([blob], file, { type: "image/png" });
      const text = `${g.shareText} ${url}`;
      if (navigator.canShare && navigator.canShare({ files: [f] })) {
        await navigator.share({ files: [f], text, title: "Pame3D" });
      } else {
        downloadBlob(blob, file);
        window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener");
        toast.success(g.shareFallback);
      }
    } catch (e) { if (e?.name !== "AbortError") toast.error(g.shareError); }
  };
  const cls = "inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-xs md:text-sm font-semibold transition-colors duration-200";
  return (
    <div className="flex gap-2">
      <button data-testid="game-download" onClick={download} className={`${cls} bg-white text-[#132A1D] border border-black/10 hover:bg-[#2E5A3B]/10`}><Download size={14} /> {g.download}</button>
      <button data-testid="game-share" onClick={share} className={`${cls} bg-[#2E5A3B] text-white hover:bg-[#C86A4B]`}><Share2 size={14} /> {g.share}</button>
    </div>
  );
};
